var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { Box, Label as ThemeLabel, Textarea as ThemeTextArea } from "theme-ui";
import { FormVariants } from "../../index";
import { randomId } from "../../utils";
import { FormError } from "./Error";
import { focusedLabelStyle, labelStyle } from "./Input";
import { relative } from "./Input";
// text area
export const TextArea = (_a) => {
    var { id, ref, placeholder, name, value, children, required, hasError, errorMessage } = _a, props = __rest(_a, ["id", "ref", "placeholder", "name", "value", "children", "required", "hasError", "errorMessage"]);
    if (!id) {
        id = randomId();
    }
    const focusSelectors = {
        "& label": focusedLabelStyle
    };
    const boxStyle = Object.assign(Object.assign({ marginBottom: 0, textarea: {
            paddingTop: 20
        } }, relative), focusSelectors);
    return (_jsxs(Box, { sx: boxStyle, className: "form-input", children: [_jsx(ThemeLabel, { htmlFor: id, sx: labelStyle, children: children }), _jsx(ThemeTextArea, Object.assign({ ref: ref, placeholder: placeholder || " ", name: name, id: id, rows: 8, defaultValue: value, sx: { variant: `forms.${FormVariants.textarea}` } }, props)), hasError && errorMessage && _jsx(FormError, { children: errorMessage })] }));
};
//# sourceMappingURL=TextArea.js.map